// CSV-02 MH-5b: 푸시 알림이 지금 작업 호텔이 아닌 다른 호텔 것일 때의 판정과,
// 호텔을 바꾼 뒤 이어서 열 알림의 보관 규칙. 화면 코드와 분리해 테스트합니다.
import { canSwitchHotel, usableHotels } from '@app/utils/activeHotel';

/** 눌렀을 때 화면을 여는 알림 종류. 그 밖의 알림(통계 등)은 전환을 묻지 않습니다. */
const NAVIGABLE_SUB_TYPES = [
  'CHAT',
  'PARTNERS_REQ',
  'JOIN_REQ',
  'USER_JOIN',
  'RESERVATION',
];

/** 전환 뒤 새로 열린 화면이 이어서 열 알림을 담아 두는 sessionStorage 키 */
export const PENDING_PUSH_KEY = 'occ-hotel-pending-push';

/** 보관한 알림을 이어서 여는 최대 시간(전환이 늦게 끝난 오래된 알림은 열지 않음) */
export const PENDING_PUSH_TTL_MS = 5 * 60 * 1000;

function toHotelId(value) {
  const id = Number(value);
  return Number.isInteger(id) && id > 0 ? id : null;
}

/**
 * 전환을 물어야 하는 알림이면 그 호텔의 접근 행을, 아니면 null을 돌려줍니다.
 * 묻는 경우: 화면을 여는 알림이고, 알림 호텔이 작업 호텔과 다르고, 그 호텔에 쓸 수 있는 접근이 있음.
 * 호텔 정보가 없는 알림(이전 서버), 접근 호텔이 1개인 사용자, 작업 호텔을 아직 모르는 경우는
 * 지금처럼 바로 엽니다.
 */
export function pushSwitchTarget(message, myInfo, myHotels) {
  const hotelId = toHotelId(message?.hotelId);
  if (hotelId == null || !NAVIGABLE_SUB_TYPES.includes(message?.subType)) {
    return null;
  }
  if (!canSwitchHotel(myHotels)) return null;
  // 작업 호텔을 아직 모르면(내 정보 읽기 전) 비교할 수 없으므로 묻지 않습니다.
  const activeHotelId = toHotelId(myInfo?.hotel?.hotelId);
  if (activeHotelId == null || activeHotelId === hotelId) return null;
  return (
    usableHotels(myHotels).find((o) => toHotelId(o.hotelId) === hotelId) || null
  );
}

/** 전환 직전에 알림을 보관합니다(전환은 화면을 새로 열기 때문). 저장소를 못 쓰면 홈만 엽니다. */
export function savePendingPush(message, now = Date.now()) {
  try {
    sessionStorage.setItem(
      PENDING_PUSH_KEY,
      JSON.stringify({ message, savedAt: now }),
    );
  } catch (e) {
    // 저장소를 쓸 수 없는 환경: 전환만 하고 알림은 이어서 열지 않습니다.
  }
}

/** 전환에 실패했을 때 보관한 알림을 지웁니다. */
export function clearPendingPush() {
  try {
    sessionStorage.removeItem(PENDING_PUSH_KEY);
  } catch (e) {
    // 저장소를 쓸 수 없는 환경
  }
}

/**
 * 새로 열린 화면에서 보관한 알림을 한 번만 꺼냅니다(꺼내면 지움).
 * 작업 호텔이 알림 호텔과 같고 보관한 지 5분 안이면 그 알림을, 아니면 null을 돌려줍니다.
 */
export function takePendingPush(activeHotelId, now = Date.now()) {
  let raw = null;
  try {
    raw = sessionStorage.getItem(PENDING_PUSH_KEY);
    sessionStorage.removeItem(PENDING_PUSH_KEY);
  } catch (e) {
    return null;
  }
  if (!raw) return null;
  try {
    const { message, savedAt } = JSON.parse(raw);
    const age = now - savedAt;
    if (!(age >= 0 && age <= PENDING_PUSH_TTL_MS)) return null;
    const hotelId = toHotelId(message?.hotelId);
    if (hotelId == null || hotelId !== toHotelId(activeHotelId)) return null;
    return message;
  } catch (e) {
    return null;
  }
}
